import React, {Component} from "react";
import ReactTooltip from 'react-tooltip'
import { isSimilarObject, getRadius } from "../../helper";

export default class LeftSide extends Component {
    shouldComponentUpdate(nextProps) {
        if(isSimilarObject(this.props, nextProps)) {
            return false;
        }
        return true;
    }

    render() {
        const { data } = this.props;

        if(!data.is_far_away) return null;

        let radius = getRadius(data.distance_far_away , '');

        return (
            <div className="left-content left-content-width" style={{ justifyContent: "start" }}>
                <a className="info-tooltip work__warning-icon" data-tip data-for='happyFace'></a>
                <ReactTooltip id='happyFace' type='dark'>
                    <span>{`Судя по геолокации, исполнитель находился далеко от места съёмки ${radius ? `(${radius})` : ''}`}</span>
                </ReactTooltip>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/MakeOrder/WarningAlert.js